define('pimUtil',[
  'module',
  'settings',
  'underscore'
], function(
  module,
  Settings,
  _
) {
  'use strict';
 	
  var pimUtil = {
    getTranslation: function(arr) {
      var result = '';

      if(arr.length > 0)
          result = arr[0].value;

      _.each(arr, function (value, lang) { 
        if(lang.toUpperCase() === 'EN')
          result = value;
      });

      if(Settings.get('lang')) {
        _.each(arr, function (value, lang) {         
          if(lang.toUpperCase() === Settings.get('lang').toUpperCase())
            result = value;
        });
      }
      return result;
    },

    /**
     * The delivery countries a price can be asked for: those of the account's
     * webshops (the country of a locale such as fr_BE, as the order prices use
     * it), sorted by name; every country when the account has no webshop.
     */
    webshopCountries: function (countries) {
      var codes = _.chain(Settings.getWebshopLocales ? Settings.getWebshopLocales() : [])
        .map(function (webshop) {
          return webshop.code.split('_')[1];
        })
        .compact()
        .map(function (code) {
          return code.toUpperCase();
        })
        .uniq()
        .value();
      var shown = codes.length === 0 ? countries : _.filter(countries, function (country) {
        return _.contains(codes, String(country.code || '').toUpperCase());
      });
      return _.sortBy(shown, 'name');
    },

    /**
     * The option combinations a PRINT product exists in (its variations), as
     * the webshop configurator uses them, or null for another product.
     *
     * data: {productType, productOptionCategories, productCodeVariations} as JSON.
     * Choices are {category index: option pimId}, the index being the one of
     * data.productOptionCategories. The options of a variation only carry
     * code / categoryCode / pimId, hence the match on either.
     */
    printCombinations: function (data) {
      var categories = data.productOptionCategories || [];
      if (data.productType !== 'PRINT') {
        return null;
      }

      var byPimId = {}, byCode = {};
      _.each(categories, function (poc, index) {
        _.each(poc.productOptions, function (po) {
          byPimId[po.pimId] = {index: index, pimId: po.pimId};
          byCode[poc.code + '|' + po.code] = {index: index, pimId: po.pimId};
        });
      });
      // One {category index: option pimId} per variation still made
      var variations = _.chain(data.productCodeVariations || [])
        .reject(function (pcv) {
          return pcv.obsolete;
        })
        .map(function (pcv) {
          var combination = {};
          _.each(pcv.productOptions, function (vpo) {
            var option = byPimId[vpo.pimId] || byCode[vpo.categoryCode + '|' + vpo.code];
            if (option) {
              combination[option.index] = option.pimId;
            }
          });
          return combination;
        })
        .value();
      if (variations.length === 0) {
        return null;
      }

      // The categories the variations decide, in their display order
      var varied = _.chain(categories)
        .map(function (poc, index) {
          return {index: index, displayOrder: poc.displayOrder || 0};
        })
        .filter(function (category) {
          return _.some(variations, function (combination) {
            return _.has(combination, category.index);
          });
        })
        .sortBy('displayOrder')
        .pluck('index')
        .value();

      var sortedOptions = function (index) {
        return _.pluck(_.sortBy(categories[index].productOptions, function (po) {
          return po.displayOrder || 0;
        }), 'pimId');
      };
      var matching = function (choices, except) {
        return _.filter(variations, function (combination) {
          return _.every(choices, function (pimId, index) {
            return Number(index) === except || !_.contains(varied, Number(index)) || combination[index] === pimId;
          });
        });
      };

      return {
        /** The option pimIds of a category the other choices can be combined with. */
        available: function (choices, index) {
          if (!_.contains(varied, index)) {
            return sortedOptions(index);
          }
          var possible = _.uniq(_.pluck(matching(choices, index), index));
          return _.filter(sortedOptions(index), function (pimId) {
            return _.contains(possible, pimId);
          });
        },

        /**
         * A full existing combination close to the choices: the category
         * `first` keeps its choice, then each category in its display order
         * keeps its own when it still fits, else gets its first value that does.
         */
        resolve: function (choices, first) {
          var result = {}, left = variations;
          var order = _.contains(varied, first) ? [first].concat(_.without(varied, first)) : varied;
          _.each(order, function (index) {
            var candidates = _.compact([choices[index]]).concat(sortedOptions(index));
            var chosen = _.find(candidates, function (pimId) {
              return _.some(left, function (combination) {
                return combination[index] === pimId;
              });
            });
            if (chosen) {
              result[index] = chosen;
              left = _.filter(left, function (combination) {
                return combination[index] === chosen;
              });
            }
          });
          _.each(categories, function (poc, index) {
            if (!_.contains(varied, index) && poc.productOptions.length) {
              result[index] = choices[index] || sortedOptions(index)[0];
            }
          });
          return result;
        }
      };
    }
  };

  module.exports = pimUtil;
});
